import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

export const CW_TRANSACTIONS_URL = 'helios-cw-transactions'

@Injectable({
  providedIn: 'root',
})
export class HttpClearwaterTransactionsService {
  constructor(private readonly http: HttpClient) {}

  getAvailableActions(): Observable<string[]> {
    return this.http.get<string[]>(`${CW_TRANSACTIONS_URL}/availableActions`)
  }
}
